export const SIZE_CODES = {
    NO_SIZE: 'NoSize'
}